<template>
  <nav class="breadcrumb" v-if="breadcrumbs.length">
    <span class="breadcrumb__title">Вы находитесь здесь:</span>
    <AppBreadcrumbsItem
      v-for="(crumb, key) in breadcrumbs"
      :key="key"
      :crumb="crumb.breadcrumb"
    />
  </nav>
</template>

<script>
import { state } from "./";
import AppBreadcrumbsItem from "./AppBreadcrumbsItem";

export default {
  name: "AppBreadcrumbs",
  components: {
    AppBreadcrumbsItem
  },
  computed: {
    breadcrumbs() {
      if (this.$route.name === "home") return [];
      return [
        {
          id: "breadcrumb_1",
          breadcrumb: {
            title: "Главная",
            to: "/"
          }
        }
      ].concat(state.breadcrumbs);
    }
  }
};
</script>

<style lang="scss">
.breadcrumb {
  font-size: 14px;
  background: url("~@/assets/images/other/breadcrumbs-bg.png") 0 0 no-repeat;
  height: 33px;
  min-width: 450px;
  line-height: 33px;
  &__title {
    color: #001e3c;
    padding: 0px 10px;
  }
}
</style>
